import React, { Component } from 'react';
import { RuleTask } from '../../components/NewOrder';
import { ApiClient } from '../../libs/apiClient';
import moment from 'moment';
import '../../css/responsive.css';
import { Tooltip } from '../index.js';
import { Popup, Label } from 'semantic-ui-react';

const apiClient = ApiClient.getInstance();
const today = moment().format("YYYY-MM-DD"); // Fecha del dia

const ruleOptions = [
    { value: -1, label: "Seleccione un tipo de regla" },
    { value: 1, label: "Sugerido Zonales" },
    { value: 2, label: "Hoja de Ruta" },
    { value: 3, label: "Facturación Electrónica - Comprobantes" },
    { value: 4, label: "Sinc. Usuarios" },
    // { value: 5, label: "Sinc. List Predet" },
    // { value: 6, label: "Sinc. List Precab" },
    // { value: 2, label: "Timbrar pagos pendientes de clientes" },
    // { value: 3, label: "Timbrar facturas, notas de crédito y débito pendientes de clientes" },
    // { value: 4, label: "Timbrar pagos pendientes de clientes Prop. 64" },
    // { value: 5, label: "Cancelar Facturas timbradas con Nota de crédito NO FISCAL" },
    // { value: 6, label: "Lectura de documentos SFTP" }
    { value: 7, label: "Comprobante de Pago de Percepción" },
    
    // { value: 8, label: "Reprocesar Pagos" },//SOLO PARA FMB
    // { value: 9, label: "Reprocesar Entradas Mercancia" },//SOLO PARA FMB
    { value: 10, label: "Actualizar contraseñas" },
    { value: 11, label: "Reprocesar Pagos" },
];

const ruleOptionsFilter = [{ value: 'ALL', label: 'Todo' }, ...ruleOptions.slice(1)];
const getUserBranch = (user) => user?.BranchName ?? user?.nombre ?? user?.Sucursal ?? '';

class SettingsBot extends Component {
    constructor(props) {
        super(props);
        this.state = {
            model: new RuleTask(),
            allTask: [],
            taskLogs: [],
            allExep: [],
            exceptionFilter: {
                startDate: today,
                endDate: today,
                DocNum: '',
                ruleLog: 'ALL',
            },
            taskLogFilter: {
                startDate: today,
                endDate: today,
                stepLog: 'ALL',
                ruleLog: 'ALL',
                docType: 'ALL',
                execTime: moment().subtract(1, 'hours').format('HH:mm'),
            },
            pagination: { // Solo hecha para task logs por ahora
                pageSize: 50,
                totalRecords: 0,
                currentPage: 1
            },
            popupOpen: false,
            availableUsers: [],
            userFilters: { name: '' },
        };
    }

    componentDidMount() {
        this.GetTaskData();
        this.FetchUsersData();
    }
    FetchUsersData = async () => {
        try {
            const response = await apiClient.GetUsersForTask();

            let users = [];
            if (response?.status === 1 && Array.isArray(response?.data)) {
                users = response.data;
            }

            this.setState({
                availableUsers: users
            });
        } catch (error) {
            console.error('SettingsBot -> FetchUsersData', error);
        }
    }

    UserKey = (user) => {
        const userId = user?.USERID ?? '';
        const userCode = (user?.USER_CODE ?? '').toString().trim();
        return `${userId}|${userCode}`;
    }

    FilteredUsers = () => {
        const { availableUsers, userFilters, model } = this.state;
        const selected = model.Users ?? [];
        const search = (userFilters.name ?? '').toLowerCase();

        return availableUsers.filter(u => {
            const fullText = `${u.U_NAME ?? ''} ${u.USER_CODE ?? ''}`.toLowerCase();
            const matchesName = fullText.includes(search);
            const isNotSelected = !selected.find(s => this.UserKey(s) === this.UserKey(u));

            return matchesName && isNotSelected;
        });
    }

    handleUserFilterChange = (field, value) => {
        this.setState(prevState => ({
            userFilters: {
                ...prevState.userFilters,
                [field]: value
            }
        }));
    }

    addUser = (user) => {
        const { model } = this.state;
        const users = model.Users ?? [];
        const exists = users.find(u => this.UserKey(u) === this.UserKey(user));

        if (!exists) {
            const newUsers = [...users, user];
            this.UpdatePropModel("Users", newUsers);
        }
    }

    removeUser = (user) => {
        const { model } = this.state;
        const users = model.Users ?? [];
        const newUsers = users.filter(u => this.UserKey(u) !== this.UserKey(user));

        this.UpdatePropModel("Users", newUsers);
    }

    addAllUsers = () => {
        const { model } = this.state;
        const users = model.Users ?? [];
        const filtered = this.FilteredUsers();

        if (filtered.length > 0) {
            const newUsers = [...users, ...filtered];
            this.UpdatePropModel("Users", newUsers);
        }
    }

    removeAllSelected = () => {
        this.UpdatePropModel("Users", []);
    }

    RenderUsersSelector = () => {
        const { model, userFilters } = this.state;
        const selected = model.Users ?? [];
        const filtered = this.FilteredUsers();

        return (
            <div className="mt-3 border-top pt-3">
                <h6 className="text-primary font-weight-bold mb-3">Usuarios a los que se les cambiará la contraseña</h6>
                <div className="row mb-2">
                    <div className="col-12 mb-1">
                        <input className="form-control form-control-sm" placeholder="Buscar nombre o código..."
                            value={userFilters.name}
                            onChange={(e) => this.handleUserFilterChange('name', e.target.value)} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 mb-2">
                        <div className="d-flex justify-content-between mb-1">
                            <small className="font-weight-bold">DISPONIBLES ({filtered.length})</small>
                            <button type="button" className="btn btn-link btn-sm p-0" onClick={this.addAllUsers}>Seleccionar todos</button>
                        </div>
                        <div className="border rounded bg-light p-2" style={{ height: 250, overflowY: 'auto' }}>
                            {filtered.map(user => (
                                <div key={this.UserKey(user)} className="d-flex justify-content-between align-items-center p-2 mb-1 bg-white border rounded">
                                    <div>
                                        <div className="small font-weight-bold">{user.U_NAME ?? user.USER_CODE}</div>
                                        <div className="text-muted" style={{ fontSize: 10 }}>
                                            {[user.USER_CODE, getUserBranch(user)].filter(Boolean).join(' | ')}
                                        </div>
                                    </div>
                                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.addUser(user)}>+</button>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-6 mb-2">
                        <div className="d-flex justify-content-between mb-1">
                            <small className="font-weight-bold">SELECCIONADOS ({selected.length})</small>
                            <button type="button" className="btn btn-link btn-sm p-0 text-danger" onClick={this.removeAllSelected}>Quitar todos</button>
                        </div>
                        <div className="border rounded p-2" style={{ height: 250, overflowY: 'auto' }}>
                            {selected.map(user => (
                                <div key={this.UserKey(user)} className="d-flex justify-content-between align-items-center p-2 mb-1 bg-light border rounded">
                                    <div>
                                        <div className="small font-weight-bold">{user.U_NAME ?? user.USER_CODE}</div>
                                        <div className="text-muted" style={{ fontSize: 10 }}>
                                            {[user.USER_CODE, getUserBranch(user)].filter(Boolean).join(' | ')}
                                        </div>
                                    </div>
                                    <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => this.removeUser(user)}>−</button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    //#endregion


    RefreshModel = model => {
        this.setState({ model })
    }

    UpdatePropModel = (key, value) => {
        const { model } = this.state
        let auxModel = model;
        auxModel[key] = value;
        if (Number(auxModel.TypeRule) === 10) {
            auxModel.payloadTask = JSON.stringify(
                (auxModel.Users ?? []).map(u => ({
                    USERID: u.USERID,
                    USER_CODE: u.USER_CODE,
                    U_NAME: u.U_NAME,
                    E_Mail: u.E_Mail,
                }))
            );
        } else {
            auxModel.payloadTask = '';
        }
        this.RefreshModel(auxModel);
    }

    CheckRuleTaskModel = model => {
        const { showAlert } = this.props;
        if (model.Date === '') {
            showAlert({ type: "warning", message: `No ha seleccionado dia de ejecución de la tarea` });
            return false;
        }
        if (model.Interval === '') {
            showAlert({ type: "warning", message: `No ha seleccionado intervalo de ejecución de la tarea` });
            return false;
        }
        if (model.Name === '') {
            showAlert({ type: "warning", message: `No ha seleccionado nombre de la tarea` });
            return false;
        }
        if (model.TypeRule === -1) {
            showAlert({ type: "warning", message: `No ha seleccionado Tipo de la tarea` });
            return false;
        }
        if (model.Interval === 'customTime' && model.CustomHour === '' && model.CustomMinutes === '') {
            showAlert({ type: "warning", message: `Seleccionaste intervalo de tiempo personalizado, debes de especificar en que tiempo se ejecutara la tarea` });
            return false;
        }
        if (Number(model.TypeRule) === 10 && (!model.Users || model.Users.length === 0)) {
            showAlert({ type: "warning", message: `Selecciona al menos un usuario para actualizar su contraseña` });
            return false;
        }
        return true;
    }

    SaveRuleTask = async () => {
        const { enableSpinner, showAlert } = this.props;
        const { model } = this.state;
        if (!this.CheckRuleTaskModel(model)) return;
        const data = {
            model: this.state.model
        }
        enableSpinner(true);
        const responseApi = await apiClient.SaveTaskRule(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message ?? ''}` });

        await this.setState({
            model: new RuleTask(),
            userFilters: { name: '' },
        })
        this.GetTaskData();
    }

    GetTaskData = async (records = 'all') => {
        const { enableSpinner, showAlert } = this.props;
        const { exceptionFilter, taskLogFilter, pagination } = this.state;

        const data = {
            records,
            exceptionFilter,
            taskLogFilter: { ...taskLogFilter, ...pagination }
        };

        enableSpinner(true);
        const responseApi = await apiClient.GetTaskData(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }

        this.UpdateState(records, responseApi);
        // showAlert({ type: "success", message: `${responseApi.message ?? ''}` });
    }

    UpdateState = (records, response) => {
        const { AllTask = [], TaskLogs = [], Exeptions = [], TotalTaskLogs = 0 } = response?.data || {};

        this.setState((prevState) => {
            let newState = {};
            switch (records) {
                case 'all':
                    newState = {
                        allTask: AllTask,
                        taskLogs: TaskLogs,
                        allExep: Exeptions,
                        pagination: { ...prevState.pagination, totalRecords: TotalTaskLogs }
                    };
                    break;
                case 'exceptions':
                    newState.allExep = Exeptions;
                    break;
                case 'taskLog':
                    newState.taskLogs = TaskLogs;
                    newState.pagination = { ...prevState.pagination, totalRecords: TotalTaskLogs };
                    break;
                default:
                    break;
            }
            return newState;
        });
    };

    DeleteTask = async (task) => {
        const { enableSpinner, showAlert } = this.props;
        const data = {
            task
        }
        enableSpinner(true);
        const responseApi = await apiClient.DeleteTask(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }

        this.GetTaskData();

    }

    DeleteTaskLog = async (id) => {
        const { enableSpinner, showAlert } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.DeleteTaskLog({ id });
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }

        this.GetTaskData('taskLog');
    }

    OnChangeInputs = (e, stateObject) => {
        const { name, value } = e.target;

        this.setState((prevState) => ({
            [stateObject]: {
                ...prevState[stateObject],
                [name]: value
            }
        }))

        if (stateObject === 'taskLogFilter') {
            this.setState(
                prevState => ({
                    pagination: { ...prevState.pagination, currentPage: 1 },
                }),
                () => {
                    if (name === 'ruleLog') this.GetTaskData('taskLog');
                }
            );
        }
    }

    Filters = (type) => {
        const stateObject = type === 'exceptions' ? 'exceptionFilter' : 'taskLogFilter';
        const { [stateObject]: { startDate, endDate, DocNum = '', stepLog = 'ALL', ruleLog = 'ALL', docType = 'ALL', execTime = '' }, popupOpen } = this.state;

        return (
            <div className="form-inline row align-items-center mb-4">
                <div className="col-auto mb-2">
                    <div className="input-group-prepend">
                        <label htmlFor="startDate" className="mr-2"><strong>Desde:</strong></label>
                    </div>
                    <input id="startDate"
                        name="startDate"
                        className="form-control border-secondary"
                        type="date"
                        placeholder="Min Date"
                        autoComplete="off"
                        value={startDate}
                        onChange={(e) => this.OnChangeInputs(e, stateObject)}
                        onKeyDown={event => event.keyCode === 13 && this.GetTaskData(type)} />
                </div>
                <div className="col-auto mb-2">
                    <div className="input-group-prepend">
                        <label htmlFor="endDate" className="mr-2"><strong>Hasta:</strong></label>
                    </div>
                    <input id="endDate"
                        name="endDate"
                        className="form-control border-secondary"
                        type="date"
                        placeholder="Max Date"
                        autoComplete="off"
                        value={endDate}
                        onChange={(e) => this.OnChangeInputs(e, stateObject)}
                        onKeyDown={event => event.keyCode === 13 && this.GetTaskData(type)} />
                </div>
                {type === 'exceptions' && (
                    <div className="col-auto mb-2">
                        <div className="input-group-prepend">
                            <label htmlFor="documentNumber" className="mr-2"><strong>No. Doc:</strong></label>
                        </div>
                        <input id="documentNumber"
                            name="DocNum"
                            type="text"
                            className="form-control border-secondary"
                            autoComplete="off"
                            value={DocNum}
                            onChange={(e) => this.OnChangeInputs(e, stateObject)}
                            onKeyDown={event => event.keyCode === 13 && this.GetTaskData(type)} />
                    </div>
                )}

                {/* {type === 'taskLog' &&
                    <div className="col-auto mb-2">
                        <div className="input-group-prepend">
                            <label htmlFor="stepLog" className="mr-2"><strong>Etapa:</strong></label>
                        </div>
                        <select
                            id='stepLog'
                            name="stepLog"
                            className="form-control w-auto border-secondary"
                            onChange={(e) => this.OnChangeInputs(e, stateObject)}
                            value={stepLog}
                        >
                            <option value={'ALL'}>Todo</option>
                            <option value={'starting'}>Iniciado</option>
                            <option value={'Process'}>En Proceso</option>
                            <option value={'ending'}>Terminado</option>
                        </select>
                    </div>
                } */}
                {type === 'taskLog' && (
                    <div className="col-auto mb-2">
                        <div className="input-group-prepend">
                            <label className="mr-2"><strong>Regla:</strong></label>
                        </div>
                        <Popup
                            flowing
                            hoverable
                            position="bottom center"
                            open={popupOpen}
                            onClose={() => this.setState({ popupOpen: false })}
                            trigger={
                                <Label
                                    className="bg-white dropdown-toggle border font-weight-light border-secondary"
                                    style={{ fontSize: 14, cursor: 'pointer' }}
                                    onMouseEnter={() => this.setState({ popupOpen: !popupOpen })}
                                    onClick={() => this.setState({ popupOpen: !popupOpen })}
                                >
                                    {ruleLog === 'ALL' ? 'Todo' : `Regla ${ruleLog}`}
                                </Label>
                            }
                        >
                            <Popup.Header>
                                <div className="card-header text-dark text-center" >
                                    Elige una regla:
                                </div>
                            </Popup.Header>
                            <Popup.Content>
                                <div className="text-dark popup-tasklog" style={{ minWidth: '250px', maxWidth: '350px' }}>
                                    <table className="table">
                                        <tbody className="d-block" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                            {ruleOptionsFilter.map((rule, index) => (
                                                <tr
                                                    key={index}
                                                    style={{
                                                        cursor: 'pointer',
                                                        transition: 'background-color 0.3s',
                                                        backgroundColor: ruleLog === rule.value ? '#f0f0f0' : 'transparent'
                                                    }}
                                                    onClick={() => {
                                                        this.OnChangeInputs({ target: { name: 'ruleLog', value: rule.value } }, stateObject);
                                                        this.setState({ popupOpen: false });
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = ruleLog === rule.value ? '#f0f0f0' : 'transparent'}
                                                >
                                                    <td className="font-weight-bold align-middle">{rule.value !== 'ALL' ? rule.value : ''}</td>
                                                    <td className='align-middle'>{rule.label}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Popup.Content>
                        </Popup>
                    </div>
                )}
                {type === 'taskLog' && false && (
                    <div className="col-auto mb-2">
                        <div className="input-group-prepend">
                            <span className="font-weight-bold" id="basic-addon1">Hora de ejecución</span>
                        </div>
                        <input
                            type="time"
                            id="horaInput"
                            className="form-control"
                            value={execTime}
                            onChange={(e) => this.OnChangeInputs(e, stateObject)}
                        />
                    </div>
                )}
                <div className="form-group col-auto col-md-6">
                    <button onClick={() => this.GetTaskData(type)} className="btn btn-link p-0 text-decoration-none">
                        <i className="fa fa-refresh" style={{ color: 'gray' }}></i>
                        <span className="font-weight-bold text-dark ml-2">Actualizar</span>
                    </button>
                </div>
            </div>
        );
    }

    ChangePageSize = (value) => {
        this.setState((prevState) => ({
            pagination: {
                ...prevState.pagination,
                pageSize: value,
                currentPage: 1 // Se devuelve al usuario a la pagina 1
            }
        }), () => this.GetTaskData('taskLog'));
    }

    ChangePage = (action) => {
        this.setState((prevState) => {
            const { pagination } = prevState;
            let newPage = pagination.currentPage;

            switch (action) {
                case 'first':
                    newPage = 1;
                    break;
                case 'previous':
                    newPage = Math.max(1, pagination.currentPage - 1);
                    break;
                case 'next':
                    newPage = Math.min(
                        Math.ceil(pagination.totalRecords / pagination.pageSize),
                        pagination.currentPage + 1
                    );
                    break;
                case 'last':
                    newPage = Math.ceil(pagination.totalRecords / pagination.pageSize);
                    break;
                default:
                    return null;
            }

            return { pagination: { ...pagination, currentPage: newPage } };
        }, () => this.GetTaskData('taskLog')); // Se ejecuta GetTaskData después de actualizar el estado
    };

    Pagination = () => {
        const { pagination: { pageSize, currentPage, totalRecords } } = this.state;

        if (totalRecords === 0) return null;

        return (
            <div className="col-12 mt-3">
                <div className="d-flex flex-wrap align-items-center justify-content-center gap-2">
                    <label
                        htmlFor="pageSize"
                        className="mb-0 mr-2 text-center"
                        style={{ fontSize: "1rem" }}>
                        Registros por página:
                    </label>
                    <select
                        className="form-control mr-3 border-secondary w-auto w-sm-100"
                        style={{ fontSize: "1rem" }}
                        name="pageSize"
                        value={pageSize}
                        onChange={(e) => this.ChangePageSize(e.target.value)}>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <div className="d-flex flex-wrap justify-content-center align-items-center">
                        <span className="mr-3 text-center" style={{ fontSize: "1rem" }}>
                            {`${(currentPage - 1) * pageSize + 1} - ${Math.min(currentPage * pageSize, totalRecords)} de ${totalRecords}`}
                        </span>
                        <div className="d-flex flex-wrap">
                            <button
                                className="btn btn-link btn-sm p-1"
                                style={{ color: "black" }}
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Primera"
                                onClick={() => this.ChangePage('first')}>
                                <i className="fas fa-chevron-left btn-first" />
                            </button>
                            <button
                                className="btn btn-link btn-sm p-1"
                                style={{ color: "black" }}
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Anterior"
                                onClick={() => this.ChangePage('previous')}>
                                <i className="fas fa-chevron-left" />
                            </button>
                            <label className="col-form-label">{currentPage}</label>
                            <button
                                className="btn btn-link btn-sm p-1"
                                style={{ color: "black" }}
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Siguiente"
                                onClick={() => this.ChangePage('next')}>
                                <i className="fas fa-chevron-right" />
                            </button>
                            <button
                                className="btn btn-link btn-sm p-1"
                                style={{ color: "black" }}
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Última"
                                onClick={() => this.ChangePage('last')}>
                                <i className="fas fa-chevron-right btn-last" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { model } = this.state
        return (
            <div>
                <div id="create-Route-form">
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">

                            <div className='row'>
                                <div className="col-12 col-lg-7 mb-4 order-0">
                                    <div className="card h-100">
                                        <div className="d-flex align-items-end row">
                                            <div className="col-sm-12">
                                                <div className="card-body bodyCar">
                                                    <h5 className="card-title text-primary">Crear Regla</h5>
                                                    <div className='row'>
                                                        <div className='col-12 col-md-6 mb-1'>
                                                            <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                    <span className="d-none d-xl-inline">Tipo regla</span>
                                                                    <span className="d-inline d-xl-none">Tipo Regla</span>
                                                                </span>
                                                                </div>
                                                            <select
                                                                name="selectisBorder"
                                                                className="form-control"
                                                                onChange={(event) => this.UpdatePropModel("TypeRule", event.target.value)}
                                                                value={model.TypeRule ?? -1}
                                                            >
                                                                {ruleOptions.map((option) => (
                                                                    <option key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            </div>
                                                        </div>

                                                        <div className='col-12 col-md-6 mb-1'>
                                                            <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                    <span className="d-none d-xl-inline">Nombre de la regla</span>
                                                                    <span className="d-inline d-xl-none">Nombre regla</span>
                                                                </span>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder='Nombre regla'
                                                                value={model.Name ?? ''}
                                                                onChange={(event) => this.UpdatePropModel("Name", event.target.value)}
                                                            />

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className="form-group col-12 col-md-6 mb-1">
                                                            <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                        <span className="d-none d-xl-inline">Dia de inicio</span>
                                                                        <span className="d-inline d-xl-none">Dia inicio</span>
                                                                    </span>
                                                            </div>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                value={model?.Date ?? ''}
                                                                onChange={(event) => this.UpdatePropModel("Date", event.target.value)}
                                                            />
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-12 col-md-6 mb-1">
                                                            <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                    <span className="d-none d-xl-inline">Hora de ejecución</span>
                                                                    <span className="d-inline d-xl-none">Hora ejecución</span>
                                                                </span>
                                                            </div>
                                                            <input
                                                                type="time"
                                                                id="horaInput"
                                                                className="form-control"
                                                                value={model.Hour ?? ''}
                                                                onChange={(event) => this.UpdatePropModel("Hour", event.target.value)}
                                                            />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className="form-group col-12 col-md-6 mb-1">
                                                            <div className="input-group">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                    <span className="d-none d-xl-inline">Intervalo de ejecución</span>
                                                                    <span className="d-inline d-xl-none">Inter ejecución</span>
                                                                </span>
                                                            </div>
                                                            <select
                                                                id="intervalSelect"
                                                                className="form-control"
                                                                value={model.Interval ?? ''}
                                                                onChange={(event) => this.UpdatePropModel("Interval", event.target.value)}
                                                            >
                                                                <option value="">Seleccione un intervalo</option>
                                                                <option value="customTime">Tiempo personalizado</option>
                                                                <option value="unique">Única</option>
                                                                <option value="daily">Diario</option>
                                                                <option value="weekly">Semanal</option>
                                                                <option value="monthly">Mensual</option>
                                                                <option value="yearly">Anual</option>
                                                            </select>
                                                            </div>
                                                        </div>

                                                        {model.Interval === 'customTime' &&
                                                            <div className="form-group col-12 col-md-6 mb-1">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                        Tiempo de ejecución
                                                                    </span>
                                                                </div>
                                                                <div className="d-flex">
                                                                    {/* Input para horas */}
                                                                    <input
                                                                        type="number"
                                                                        id="hoursInput"
                                                                        className="form-control"
                                                                        min="0"
                                                                        placeholder="Horas"
                                                                        value={model.CustomHour ?? ''}
                                                                        onChange={(event) => this.UpdatePropModel("CustomHour", event.target.value)}
                                                                        style={{ marginRight: "10px" }}
                                                                    />
                                                                    {/* Input para minutos */}
                                                                    <input
                                                                        type="number"
                                                                        id="minutesInput"
                                                                        className="form-control"
                                                                        min="0"
                                                                        max="59" // Máximo 59 para minutos
                                                                        placeholder="Minutos"
                                                                        value={model.CustomMinutes ?? ''}
                                                                        onChange={(event) => this.UpdatePropModel("CustomMinutes", event.target.value)}
                                                                    />
                                                                </div>
                                                            </div>

                                                        }
                                                    </div>

                                                    {Number(model.TypeRule) === 10 && this.RenderUsersSelector()}
                                                    <div className="d-flex justify-content-end mb-3 mt-2">
                                                        <button
                                                            type="button"
                                                            onClick={this.SaveRuleTask}
                                                            className="btn btn-success"
                                                        >
                                                            Agregar Regla
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-5 order-1 mb-4">
                                    <div className="card h-100">
                                        <div className="card-header d-flex align-items-center justify-content-between">
                                            <h5 className="card-title m-0 me-2">TAREAS ACTIVAS</h5>
                                        </div>
                                        <div className="card-body">
                                            <div style={{ maxHeight: '25vh', overflowY: 'auto' }}>
                                                <ul className="list-unstyled p-0 m-0">
                                                    {this.state.allTask.map((task, index) => {
                                                        let usersCount = 0;
                                                        if (Number(task?.taskType) === 10) {
                                                            try { usersCount = JSON.parse(task?.payloadTask || '[]').length; } catch (e) { usersCount = 0; }
                                                        }
                                                        return (
                                                            <li key={index} className="d-flex justify-content-between align-items-center mb-2 p-2 border rounded">
                                                                <div>
                                                                    <small className="d-block mb-1">{task?.nameTask ?? ''}</small>
                                                                    <h6 className="mb-1">Regla: {ruleOptions.find(rule => rule.value === Number(task?.taskType))?.label ?? ''}</h6>
                                                                    <h6 className="mb-1">Fecha inicio: {task?.execDate ?? ''}</h6>
                                                                    <h6 className="mb-1">En horario: {task?.execTime ?? ''}</h6>
                                                                    {task.interval === "customTime" ?
                                                                        <>
                                                                            <h6 className="mb-0">Intervalo personalizado</h6>
                                                                            <h6 className="mb-0">Horas: {task?.customHour ?? ''}</h6>
                                                                            <h6 className="mb-0">Min: {task?.customMinutes ?? ''}</h6>
                                                                        </>
                                                                        :
                                                                        <h6 className="mb-0">Intervalo: {task?.interval ?? ''}</h6>
                                                                    }
                                                                    {Number(task?.taskType) === 10 &&
                                                                        <h6 className="mb-0">Usuarios: {usersCount}</h6>
                                                                    }
                                                                </div>
                                                                <i
                                                                    className="fa fa-trash text-danger mr-4"
                                                                    style={{ cursor: 'pointer', fontSize: '1.6vh' }}
                                                                    onClick={() => this.DeleteTask(task)}
                                                                ></i>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            {/* LOGS */}
                            {/* Se puso false para que no se vea para LLAMAGAS */}
                            {false && <div className="row">
                                <div className="col-12 col-lg-7 mb-4 order-0">
                                    {this.Filters('exceptions')}
                                    <div className="card" style={{ minHeight: '450px' }}>
                                        <div className="d-flex align-items-end row">
                                            <div className="col-sm-12">
                                                <div className="card-body">
                                                    <h5 className="card-title text-primary">Excepciones</h5>
                                                    <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                        <ul className="list-unstyled p-0 m-0">
                                                            {this.state.allExep.map((exeption, index) => {
                                                                return (
                                                                    <li key={index} className="d-flex justify-content-between align-items-center mb-2 p-2 border rounded">
                                                                        <div>
                                                                            <small className="d-block mb-1">Fecha Doc: {moment(exeption?.DocDate).utc().format('YYYY-MM-DD') ?? ''}</small>
                                                                            <h6 className="mb-1">Socio: {exeption?.CardName ?? ''}</h6>
                                                                            <h6 className="mb-1">No. Doc: {exeption?.DocNum ?? ''}</h6>
                                                                            <h6 className="mb-1">Tipo Doc: {exeption?.TypeDoc ?? ''}</h6>
                                                                            <h6 className="mb-1">Error: {exeption?.U_FMB_TimbraError ?? ''}</h6>
                                                                        </div>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-lg-5 order-1 mb-4">
                                    {this.Filters('taskLog')}
                                    <div className="card" style={{ minHeight: '450px' }}>
                                        <div className="card-header d-flex align-items-center justify-content-between">
                                            <h5 className="card-title m-0 me-2">{`TASK LOGS (${this.state.pagination.totalRecords})`}</h5>
                                        </div>
                                        <div className="card-body">

                                            <div style={{ maxHeight: '300px', overflowY: this.state.taskLogs.length > 5 ? 'auto' : 'visible' }}>
                                                <ul className="list-unstyled p-0 m-0">
                                                    {this.state.taskLogs.map((taskLog, index) => {
                                                        return (
                                                            <li key={index} className="d-flex justify-content-between align-items-center mb-2 p-2 border rounded">
                                                                <div style={{ position: 'relative' }}>
                                                                    <small className="text-muted d-block mb-1">{taskLog.nameTask ?? ''}</small>
                                                                    <h6 className="mb-0">Hora de ejecución: {taskLog.sys_date ?? ''}</h6>
                                                                    <h6 className="mb-0">
                                                                        Etapa: {taskLog?.task_status ?? ''}
                                                                        {(taskLog.task_data) !== '' &&

                                                                            <Tooltip IconType={'times-circle'} color='red' view={'ObjectData'} tips={(taskLog.task_data) !== '' ? JSON.parse(taskLog.task_data) : {}} style={{ position: 'up' }} />

                                                                        }
                                                                    </h6>

                                                                </div>
                                                                <i
                                                                    className="fa fa-trash text-danger mr-4"
                                                                    style={{ cursor: 'pointer', fontSize: '1.6vh' }}
                                                                    onClick={() => this.DeleteTaskLog(taskLog?.id)}
                                                                ></i>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                            {this.Pagination()}
                                        </div>
                                    </div>
                                </div>

                            </div>}
                        </div>
                        <div className="content-backdrop fade"></div>
                    </div>
                </div>
            </div>
        )
    }

    esJSONValido(str) {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }


    ShowInfoByTaskLog = (message) => {
        const { showAlert } = this.props;
        showAlert({ type: "info", message: `${message ?? ''}`, timeOut: 5000 });
    }
}

export default SettingsBot;
